import { render, staticRenderFns } from "./PageEventGame.vue?vue&type=template&id=a596c98e&"
import script from "./PageEventGame.vue?vue&type=script&lang=js&"
export * from "./PageEventGame.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGame.vue?vue&type=style&index=0&id=a596c98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports